import { Row, Col, Button, Image } from 'react-bootstrap';

import openJobs from './openPositions.js';


function OpenJobsLinkList() {
   const openPositionsAvailable = areOpenPositionsAvailable();
   if(openPositionsAvailable) {
    var counter=0;

    return (
        <Row className='py-3'>
            <Col>
                <ul className='joblinklist'>
                    {openJobs.map(job => (
                        <li>
                            <a href={"#job-" + counter++}>{job.title}</a>
                        </li>
                    ))}
                </ul>
            </Col>
        </Row>
   );
   }

   return null;
}

function areOpenPositionsAvailable() {
    return openJobs.length > 0;
}

export default OpenJobsLinkList;